import { j as e } from "./Spinner-dTAYYnIx.js";
import { u as n } from "./useResizeObserver-ghdBe7Hs.js";
import { styled as s } from "styled-components";
import { j as m } from "./style-8UHgYe1v.js";
const r = (t) => typeof t == "number" && `${t}px`, a = s.div`
  ${m("width, height")}

  width: ${({ $width: t }) => r(t)};
  height: ${({ $height: t }) => r(t)};
  display: block;
`;
s.div`
  display: inline-block;
`;
const u = ({
  children: t,
  variant: i = "height"
}) => {
  const [{ height: o, width: h }, p] = n(), d = {
    $height: i === "height" && o,
    $width: i === "width" && h
  };
  return /* @__PURE__ */ e.jsx(a, { ...d, children: /* @__PURE__ */ e.jsx("div", { ref: p, children: t }) });
};
export {
  u as R
};
